const curriculum = {
  spanish:
  {
    title: {
      name: "Sergio Pascual",
      profession: "Web Developer | Frontend Developer"
    },
    socials: {
      tlf: "+34 610 590 564",
      city: "Valencia, España",
      portfolio: {
        id: 1,
        title: "sepape.com",
        link: "https://sepape.com/",
      },
      email: {
        id: 2,
        title: "sepape.frontend@sepape.com",
        link: "sepape.frontend@sepape.com",
      },
      linkedin: {
        id: 3,
        title: "LinkdIn",
        link: "https://www.linkedin.com/in/sergio-pascual-pe/",
      },
    },
    education: {
      title: "EDUCACIÓN",
      school: {
        esat: {
          id: 1,
          title: "Postgrado Desarrollo Web Front-End",
          place: "ESAT",
          date: "10/2021 - 07/2022",
          location: "Valencia, España",
        },
        udemy: {
          id: 2,
          title: "Desarrollo Web",
          place: "Udemy",
          date: "07/2020 - 10/2021",
          location: "Remoto, España",
        },
        superior: {
          id: 3,
          title: "Grado Superior Diseño y animación",
          place: "La Florida Universitaria",
          date: "10/2016 - 07/2018",
          location: "Catarroja, España",
        },
        middle: {
          id: 4,
          title: "Grado medio Informática",
          place: "La Florida Universitaria",
          date: "10/2014 - 07/2016",
          location: "Catarroja, España",
        },
      },
    },
    experience: {
      title: "EXPERIENCIA",
      wakkos: {
        id: 1,
        title: "Consultora Wakkos",
        date: "01/2022 - Actualidad",
        location: "Remoto",
        works: {
          surgease: {
            id: 1,
            title: "Web de SurgEase Innovations.",
            information: {
              title1: {
                title: "Encargado de arreglar todos los issues de la web de SurgEase (HTML,ReactJS, SASS, TypeScript).",
                id: 1,
              },
              title2: {
                title: "Trabajando cerca del equipo de diseño con cada issue que iba apareciendo y requiriendo de arreglo.",
                id: 2,
              },
              title3: {
                title: "El encargado del diseño utilizaba Figma y la comunicación era mediante vídeos con cada issue que iba apareciendo.",
                ide: 3,
              },
              title4: {
                title: "Gestión del proyecto mediante Notion.",
                id: 4,
              },
            },
          },
          boream: {
            id: 2,
            title: "Proyecto Boream.",
            information: {
              title1: {
                title: "Encargado de crear todos los componentes (PUG/JADE, SASS, Angular).",
                id: 1,
              },
              title2: {
                title: "Trabajando en un equipo de 3 personas cerca del product owner desde la definición de requerimientos hasta la creación de nuevos componentes.",
                id: 2,
              },
              title3: {
                title: "La encargada del diseño utilizaba Figma y la gestión era mediante la aplicación Trello.",
                ide: 3,
              },
            },
          },
          ayuntamiento: {
            id: 3,
            title: "Web del ayuntamiento de Madrid.",
            information: {
              title1: {
                title: "Encargado de crear y editar componentes existentes (HTML, SASS, JavaScript).",
                id: 1,
              },
              title2: {
                title: "Trabajando cerca del equipo de diseño y del product owner desde la definición de requerimientos hasta en la creación de nuevos componentes.",
                id: 2,
              },
              title3: {
                title: "Las personas encargadas del diseño utilizaban Figma y la gestión era mediante la aplicación Trello.",
                ide: 3,
              },
            },
          },
        },
      },
    },
    skills: {
      title: "HABILIDADES",
      languages: {
        id: 1,
        title: "Lenguajes",
        content: " (HTML, CSS, SASS, JavaScript, TypeScript)",
      },
      software: {
        id: 2,
        title: "Software & Herramientas",
        content: " (Git, NPM, VS Code, POO, CMD, Wordpress, Photoshop, Figma, Trello, Notion, Scrum)",
      },
      library: {
        id: 3,
        title: "Librerías & Frameworks",
        content: " (ReactJS, React Hooks, ReactNative, Angular, Jest, React Testing Library, styled components, Vite, Vitest)",
      },
      softskills: {
        id: 4,
        title: "Soft Skills",
        content: " (Proactivo, trabajo en equipo, responsable, autosuficiente)",
      },
    },
    download: {
      title: "Descargar el CV",
      href: "./../../../../resources/pdf/CVSergioPascual.pdf",
      name: "CVSergioPascual.pdf",
    },
  },
  english:
  {
    title: {
      name: "Sergio Pascual",
      profession: "Web Developer | Frontend Developer"
    },
    socials: {
      tlf: "+34 610 590 564",
      city: "Valencia, Spain",
      portfolio: {
        id: 1,
        title: "sepape.com",
        link: "https://sepape.com/",
      },
      email: {
        id: 2,
        title: "sepape.frontend@sepape.com",
        link: "sepape.frontend@sepape.com",
      },
      linkedin: {
        id: 3,
        title: "LinkdIn",
        link: "https://www.linkedin.com/in/sergio-pascual-pe/",
      },
    },
    education: {
      title: "EDUCATION",
      school: {
        esat: {
          id: 1,
          title: "Postgraduate in Front-End Development",
          place: "ESAT",
          date: "10/2021 - 07/2022",
          location: "Valencia, Spain",
        },
        udemy: {
          id: 2,
          title: "Frontend Development ",
          place: "Udemy",
          date: "07/2020 - 10/2021",
          location: "Remote, Spain",
        },
        superior: {
          id: 3,
          title: "Higher Degree in 3D Design and Animation",
          place: "La Florida Universitaria",
          date: "10/2016 - 07/2018",
          location: "Catarroja, Spain",
        },
        middle: {
          id: 4,
          title: "Intermediate Degree in Computer Science",
          place: "La Florida Universitaria",
          date: "10/2014 - 07/2016",
          location: "Catarroja, Spain",
        },
      },
    },
    experience: {
      title : "EXPERIENCE",
      wakkos: {
        id: 1,
        title: "Wakkos Consulting",
        date: "01/2022 - Present",
        location: "Remote",
        works: {
          surgease: {
            id: 1,
            title: "Website for SurgEase Innovations.",
            information: {
              title1: {
                title: "Responsible for fixing all issues on the SurgEase website (HTML, ReactJS, SASS, TypeScript).",
                id: 1,
              },
              title2: {
                title: "Working closely with the design team for each emerging issue that required fixing.",
                id: 2,
              },
              title3: {
                title: "The design lead used Figma, and we communicated through videos for each issue that arose.",
                ide: 3,
              },
              title4: {
                title: "Project management using Notion.",
                id: 4,
              },
            },
          },
          boream: {
            id: 2,
            title: "Boream project.",
            information: {
              title1: {
                title: "Responsible for creating all components (PUG/JADE, SASS, JavaScript, Angular).",
                id: 1,
              },
              title2: {
                title: "Working in a team of 3 people closely with the product owner from requirements definition to the creation of new components.",
                id: 2,
              },
              title3: {
                title: "The design lead used Figma, and we managed the project on Trello.",
                ide: 3,
              },
            },
          },
          ayuntamiento: {
            id: 3,
            title: "Madrid City Hall website.",
            information: {
              title1: {
                title: "Responsible for creating and editing existing components (HTML, SASS, JavaScript).",
                id: 1,
              },
              title2: {
                title: "Working closely with the design team and the product owner from requirements definition to the creation of new components.",
                id: 2,
              },
              title3: {
                title: "The design leads used Figma, and we managed the project with Trello.",
                ide: 3,
              },
            },
          },
        },
      },
    },
    skills: {
      title: "SKILLS",
      languages: {
        id: 1,
        title: "Languages",
        content: " (HTML, CSS, SASS, JavaScript, TypeScript)",
      },
      software: {
        id: 2,
        title: "Software & Work tools",
        content: " (Git, NPM, VS Code, POO, CMD, Wordpress, Photoshop, Figma, Trello, Notion, Scrum)",
      },
      library: {
        id: 3,
        title: "Libraries & Frameworks",
        content: " (ReactJS, React Hooks, ReactNative, Angular, Jest, React Testing Library, styledcomponents, Vite, Vitest)",
      },
      softskills: {
        id: 4,
        title: "Soft Skills",
        content: " (Proactive, teamwork, responsible, self-sufficient)",
      },
    },
    download: {
      title: "Download Resume",
      href: "./../../../../resources/pdf/ResumeSergioPascual.pdf",
      name: "ResumeSergioPascual.pdf",
    },
  },
};

export default curriculum;